import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const SaveFailure = props => {
  const { saveCouponError } = props;

  const buttonConfig = {
    primary: {
      label: 'KAYITLI KUPONLARIM',
      onClick: props.onPrimaryButtonClick
    }
  };

  const failureMessage
    = saveCouponError && EnvironmentManager.getMessageText({ key: `${saveCouponError.domain}${saveCouponError.code}` })
    || 'Sistemsel bir sorundan dolayı kuponun oynanamadı. Lütfen tekrar dene.';

  return (
    <Message type="none" buttonConfig={ buttonConfig } >
      <p>{ failureMessage }</p>
    </Message>
  );
};

SaveFailure.propTypes = {
  onPrimaryButtonClick: PropTypes.func.isRequired,
  saveCouponError: PropTypes.object
};

export default SaveFailure;
